<div id="labs">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class=" inner-card">
                    <h4 class="card-title ">Physics Lab</h4>
                    <div class="card-body text-justify">
                      <p class="inner-lead"><i>"Time crumbles things; everything grows under the POWER of Time and is FORGOTTEN through the lapse of Time." </i></p>
                        <!-- <h5>Physics XII eBooks Link</h5>
                        <hr class="opacity-100">
                        <div class="ranked">
                            <table class="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">Particular</th>
                                    <th scope="col">Link</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?leph1=0-8">https://ncert.nic.in/textbook.php?leph1=0-8</a></td>
                                  </tr>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?leph2=0-6">https://ncert.nic.in/textbook.php?leph2=0-6</a></td>
                                  </tr>
                                  
                                </tbody>
                              </table>
                        </div>

                        <h5>Physics XI eBooks Link</h5>
                        <hr class="opacity-100">
                        <div class="ranked">
                            <table class="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">Particular</th>
                                    <th scope="col">Link</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?keph1=0-8">https://ncert.nic.in/textbook.php?keph1=0-8</a></td>
                                  </tr>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?keph2=0-7">https://ncert.nic.in/textbook.php?keph2=0-7</a></td>
                                  </tr>
                                  
                                </tbody>
                              </table>
                        </div> -->
                        <div class="row">
                          <div class="col-6 text-center mb-4">
                            <a href="/assets/img/campus/labs/4.jpg" data-lightbox="Physics"><img src="/assets/img/campus/labs/4.jpg" alt="Physics" class="img-fluid rounded"></a>
                            <h5 class="text-center mt-4">Physics</h5>
                          </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>